<div class="modal-header"><h2 class="modal-title">Password Change</h2></div>
<div class="modal-body">
  @if (userInfo) {
    <div>
      <dx-form [formData]="userInfo" validationGroup="statusChangeData">
        <dxi-item dataField="userName"></dxi-item>
        <dxi-item dataField="currentPassword" [editorOptions]="{ mode: 'password' }">
          <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="newPassword1" [editorOptions]="{ mode: 'password' }">
          <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="newPassword2" [editorOptions]="{ mode: 'password' }">
          <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
        </dxi-item>
      </dx-form>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="save()">Save</button>
  <button type="button" class="btn btn-default" (click)="cancel()">Cancel</button>
</div>
